import {getEnv} from 'services/apis'

const STRIPE_PROD_KEY =
  'pk_live_51HoXmmCs4ZjEuT7GyrYGhs6XhACOGlVHiIETbLGY0nvEDpvSptNFePEc1G5c79BwEWugMYaOlEKkudqCFGQclfKI00lBVr3TgW'
const STRIPE_DEV_KEY =
  'pk_test_51HoXmmCs4ZjEuT7GulOIma3iT2ffAj9ZRQTVObRvha4dSlNf404rd9hWrWJCJURpjCL5nNiuA0LrXvsXbNFj2uie00uCDL1k1E'

export const stripeKey = getStripeApiKey()

function getStripeApiKey() {
  const env = getEnv()
  return env === 'production' ? STRIPE_PROD_KEY : STRIPE_DEV_KEY
}
